import { render } from "./TrfButtonUpLoadAttachment.vue?vue&type=template&id=53e6f312&scoped=true"
import script from "./TrfButtonUpLoadAttachment.vue?vue&type=script&lang=js"
export * from "./TrfButtonUpLoadAttachment.vue?vue&type=script&lang=js"

import "./TrfButtonUpLoadAttachment.vue?vue&type=style&index=0&id=53e6f312&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e6f312"],['__file',"src/components/ButtonUpload/TrfButtonUpLoadAttachment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53e6f312"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53e6f312', __exports__)) {
    console.log('reload')
    api.reload('53e6f312', __exports__)
  }
  
  module.hot.accept("./TrfButtonUpLoadAttachment.vue?vue&type=template&id=53e6f312&scoped=true", () => {
    console.log('re-render')
    api.rerender('53e6f312', render)
  })

}


export default __exports__